module.exports = __webpack_public_path__ + "coin_NXS.png?8b36bd6f091fc8ec7384315343af0686";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_NXS.png
// module id = 460
// module chunks = 2